import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuItem, Select } from "@mui/material";
import { useCommonDataContext } from '../context/CommonDataProvider';
import AutoCompleteAllCampaign from '../components/shared/AutoCompleteAllCampaign';
import AllCampaignTable from '../components/AllCampaignsTable';
import { selectFieldStyle } from '../styles/MaterialUiComponentsStyles';



function createColumns(headers){
  const columns =  headers.map(header =>({
    field:header,
    headerName:header,
    width:400,
  }))
  columns.unshift({field:'repName',headerName:'Rep Name',width:400})
  return columns;
}

const AllCampaigns = () => {
    const { campaignData } = useCommonDataContext();
    const navigate = useNavigate();
    const [tableLoading, setTableLoading] = useState(true);
    const [period, setPeriod] = useState({
        startYear: 2024,
        endYear: 2024,
        startMonth: 2,
        endMonth: 2,
    });
    const [data, setData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState('');
    const [createdCols,setCreatedCols] = useState([]);

    const columns = [
        { field: "repName", headerName: "Rep Name", width: 400 },
        { field: "CALFIT TAB 15's", headerName: "CALFIT TAB 15's", width: 400 },
        { field: "SONI", headerName: "SONI", width: 400 },
    ];

    const fetchLatestDataDate = async () => {
        const userDetails = JSON.parse(localStorage.getItem('token'));
        const token = userDetails?.result?.token;

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/getlatestDate`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 401) {
                alert('Session Expired, Please login again');
                localStorage.removeItem('token');
                navigate('/login');
                return;
            }
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const jsonData = await response.json();
            setPeriod({
                startYear: jsonData.year,
                endYear: jsonData.year,
                startMonth: jsonData.month,
                endMonth: jsonData.month,
            });
            console.log(jsonData)
            if (campaignData && campaignData.length > 0) {
              setSelectedCampaign(campaignData[0]._id)
                fetchData(jsonData, campaignData[0]._id);
            }
        } catch (error) {
            console.error('Error fetching latest data date:', error);
        }
    };

    const fetchData = async (latestDate, campaignId) => {
        const userDetails = JSON.parse(localStorage.getItem('token'));
        const token = userDetails?.result?.token;

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/product/${campaignId}?startyear=${latestDate.year}&endyear=${latestDate.year}&startingmonth=${latestDate.month}&endingmonth=${latestDate.month}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 401) {
                alert('Session Expired, Please login again');
                localStorage.removeItem('token');
                navigate('/login');
                return;
            }
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const jsonData = await response.json();
            setRawData(jsonData);
            console.log(jsonData)
            setData(jsonData.data);
            const cols = createColumns(jsonData.headers);
            setCreatedCols(cols);
            setTableLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const userDetails = JSON.parse(localStorage.getItem('token'));
        const role = userDetails?.result?.role;
        if (role === 'REGULAR_USER') {
            navigate('/redirect');
        } else {
            fetchLatestDataDate();
        }
    }, [campaignData]);

    useEffect(() => {
        if (selectedCampaign) {
            fetchData(period, selectedCampaign);
        }
    }, [selectedCampaign]);

    const handleCampaignChange = (event) => {
        setSelectedCampaign(event.target.value);
    };

    return (
        <div className='h-auto w-full flex flex-col p-4 gap-7 mb-12'>
            <div className='bg-gradient-to-r from-[#49e6b7] to-white p-5 pb-7 flex flex-col gap-4 rounded-2xl mt-3 bg-cover bg-center z-0'>
                <div className="flex justify-between">
                    <h1 className='text-4xl font-bold font-sans text-skin-base'>CAMPAIGNS</h1>
                </div>
                {campaignData.length > 0 ? (
                    <>
                        <div className='flex rounded-lg'>
                            <AutoCompleteAllCampaign
                                setSearchData={setData}
                                period={period}
                                setPeriod={setPeriod}
                                selectedCampaign={selectedCampaign}
                                setTableLoading={setTableLoading}
                                setRawData={setRawData}
                                fetchData={fetchData}
                                setCreatedCols={setCreatedCols}
                            />
                        </div>
                        <div>
                            <Select
                                sx={selectFieldStyle}
                                labelId="rep-label"
                                id="selectedCampaign"
                                name='selectedCampaign'
                                value={selectedCampaign}
                                label="Rep"
                                onChange={handleCampaignChange}
                                className="text-white font-bold bg-white"
                            >
                                {campaignData.map((campaign) => (
                                    <MenuItem className='uppercase' key={campaign._id} value={campaign._id}>{campaign.name}</MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div>
                            <AllCampaignTable data={data} columns={createdCols} tableLoading={tableLoading} setTableLoading={setTableLoading} />
                        </div>
                    </>
                ) : (
                    <div>No campaign data available</div>
                )}
            </div>
        </div>
    );
};

export default AllCampaigns;
